module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Bold.fa86dc31.woff2";